export const conversion = {
    methods : {
        dataURItoBlob : function(dataURI) {
            // console.log('dataURI', dataURI);
            // convert base64 to raw binary data held in a string
            // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
            var byteString = atob(dataURI.split(',')[1]);
            // console.log('byteString', byteString);

            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            // console.log('mimeString', mimeString);

            // write the bytes of the string to an ArrayBuffer
            var ab = new ArrayBuffer(byteString.length);
            // console.log('ab', ab);

            // create a view into the buffer
            var ia = new Uint8Array(ab);
            // console.log('ia', ia);

            // set the bytes of the buffer to the correct values
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            // console.log('ia', ia);

            // write the ArrayBuffer to a blob, and you're done
            var blob = new Blob([ab], {type: mimeString});
            // console.log('blob', blob);
            return blob;
        }
    }
}
